import { createRouter, createWebHashHistory, createMemoryHistory } from 'vue-router'

// V3 flow (§18 hoofdjourney):
// intro → (globale uitleg) → home/rad → game(uitleg→spel→score) → … →
// game over → shop → opt-ins → eindscherm.  Prize Reveal is a separate app.
import IntroView from '@/views/IntroView.vue'
import UitlegView from '@/views/UitlegView.vue'
import HomeView from '@/views/HomeView.vue'
import GameView from '@/views/GameView.vue'
import ShopView from '@/views/ShopView.vue'
import OptInFlowView from '@/views/OptInFlowView.vue'
import EindView from '@/views/EindView.vue'

const router = createRouter({
  history:
    import.meta.env.MODE === 'development'
      ? createWebHashHistory(import.meta.env.BASE_URL)
      : createMemoryHistory(),
  routes: [
    { path: '/', name: 'intro', component: IntroView },
    { path: '/uitleg', name: 'uitleg', component: UitlegView },
    { path: '/home', name: 'home', component: HomeView },
    { path: '/game', name: 'game', component: GameView },
    { path: '/shop', name: 'shop', component: ShopView },
    { path: '/opt-in', name: 'optin', component: OptInFlowView },
    { path: '/eind', name: 'eind', component: EindView },
  ],
})

router.beforeEach((to, from, next) => {
  if (window._ddm) {
    window._ddm.trigger('routeChange.ready', {
      data: {
        page: {
          environment: import.meta.env.VITE_GTM_ENV,
          web_view: true,
          page_path: to.fullPath,
        },
      },
    })
  }
  next()
})

export default router
